import axios from "axios";
import _, { isEmpty } from "lodash";
import moment from "moment-timezone";
import Swal from "sweetalert2";
import { defaultCurrency, transcationArrayType, walletType, WITHDRAWAL_RANGE, WITHDRAWAL_STATUS } from "../constant/constant.js";
const BASE_URL = "https://real11-images.s3.ap-south-1.amazonaws.com/";
export const IST_TIMEZONE = "Asia/Kolkata";
export const DEFAULT_IST_DATE_TIME_FORMAT = "DD MMM YYYY, hh:mm A";

export const getSweetAlert = (type, topic) => {
  Swal.fire({
    position: 'top-end',
    icon: type,
    title: topic,
    showConfirmButton: false,
    timer: 3000
  })
}



const logout = () => {
  localStorage.clear()
  window.location.href = '/login';
}

const apiClient = axios.create({
  baseURL: "http://localhost:5050",
  withCredentials: true, // Sends cookies with each request
});

export const interCeptor = (token) => {
  apiClient.interceptors.request.use(async function (config) {
    // resetLogoutTimeout(logout);
    const getItem = localStorage.getItem('persist:prediction')
    const tokens = !isEmpty(getItem) ? JSON.parse(JSON.parse(getItem).loginSlice).token : ''
    Object.assign(config.headers, { auth_token: tokens })
    
    // if (!config.headers['X-CSRF-Token']) {
    //   const { data } = await axios.get('/api/csrf-token');
    //   config.headers['X-CSRF-Token'] = data.csrfToken;
    // }
    return config;
  }, function (error) {
    return Promise.reject(error);
  });

  apiClient.interceptors.response.use(function (response) {
    return response;
  }, async function (error) {
    if (error?.response?.data?.error === 'Session Token expired') {
      localStorage.removeItem('persist:prediction');
      return window.location.reload();
    }
    getSweetAlert('error', error?.response?.data?.error)
  });
  
}
 export const getPriceByCurrency = (amount) => {
  	if (defaultCurrency == 'INR') {
  		return amount + ' INR';
  	} else {
  		return '$ ' + amount;
  	}
  }

  const calculatePageIndex = (currentPage, pageSize, offset) => {
    return (currentPage - 1) * pageSize + offset;
};

export const categoryParse = async (data) => {
  return data.map(({ _id, category_name, category_index }) => ({ _id, value: category_name, label: category_name , category_index }));
}

export const parseGameTranscation = async(transcation, type, dateTime, page, size, payment_mode, wallet_type) => {

  let data = { page, size };

  if(Object.keys(transcation).length !== 0) {
    const removeEmptyValue =  Object.fromEntries(
      Object.entries(transcation).filter(([key, value]) => value !== null && value !== undefined && value !== '')
    );

      data = {...data, ...removeEmptyValue};
  }

  if(type?._id !== 0 && type?.value && type.value !== 'All') {
    data = {...data, txn_type: type.value};
  }
  if(payment_mode?._id !== 0) {
    data = {...data, payment_mode :payment_mode?._id};
  }
  if(wallet_type?.value && wallet_type.value !== 'All') {
    data = {...data, wallet_type: wallet_type.value};
  }


  if(Object.keys(dateTime).length !== 0) {
   const removeEmptyValue =  Object.fromEntries(
      Object.entries(dateTime).filter(([key, value]) => value !== null && value !== undefined && value !== '')
    );
      data = {...data, ...removeEmptyValue};
  }


  return data;
}

// export const getTrancationType = (type) => {
  
//   const transcationLable = Object.keys(transcationType).find(key => transcationType[key] === type);
//   return { text: transcationText[transcationLable], amountType: type  == 3 ? "DB" : "CB"}
// }

export const getTrancationType = (type) => {
  const transcation = transcationArrayType.find(key => key._id === type);
  // if(transcation) 
  // return { text: transcation.label || '', amountType: type  == 3 ? "DB" : "CR"}
  // else
  const signType =  (_.indexOf([ 2, 3, 10, 13, 15, 23, 29, 18, 38, 43, 46], type) >= 0) ? "DB" : "CR"
  return { text: transcation?.label || '', amountType: signType}
}

export const parseUserData = (user, verifiedType, dateTime, page, size, bankAccountVerify ) => {
  
  let data = { page, size };
  
  if(Object.keys(user).length !== 0) {
    const removeEmptyValue =  Object.fromEntries(
      Object.entries(user).filter(([key, value]) => value !== null && value !== undefined && value !== '')
    );
      data = {...data, ...removeEmptyValue};
  }

  if(verifiedType._id != -1) 
    data = {...data, verified_type : verifiedType._id};

  if(bankAccountVerify._id !== 0) 
  data = {...data, bank_account_verify : bankAccountVerify._id == 1 ? 1 : 2};

  if(Object.keys(dateTime).length !== 0) {
   const removeEmptyValue =  Object.fromEntries(
      Object.entries(dateTime).filter(([key, value]) => value !== null && value !== undefined && value !== '')
    );
      data = {...data, ...removeEmptyValue};
  }
  
  return data;
}

export const parseAffiliateUser = (user, page, size ) => {
  
  let data = { page, size };
  
  if(Object.keys(user).length !== 0) {
    const removeEmptyValue =  Object.fromEntries(
      Object.entries(user).filter(([key, value]) => value !== null && value !== undefined && value !== '')
    );
      data = {...data, ...removeEmptyValue};
  }
  
  return data;
}

export const parseUserCyberFraudData = (user, page, size) => {
  let data = { page, size ,is_cyber_fraud: 1};
  if(Object.keys(user).length !== 0) {
    const removeEmptyValue =  Object.fromEntries(
      Object.entries(user).filter(([key, value]) => value !== null && value !== undefined && value !== '')
    );
      data = {...data, ...removeEmptyValue};
  }
  return data;
}

export const getDate = (date) => {
  const dateFormat = moment(date).tz(IST_TIMEZONE).format('llll');
  return dateFormat;
}

export const formatISTDateTime = (date, format = DEFAULT_IST_DATE_TIME_FORMAT) => {
  if (!date) return "—";
  return moment(date).tz(IST_TIMEZONE).format(format);
}

export const toISTDatetimeLocal = (date) => {
  if (!date) return "";
  return moment(date).tz(IST_TIMEZONE).format("YYYY-MM-DDTHH:mm");
}

export const istDatetimeLocalToISOString = (date) => {
  if (!date) return "";
  return moment.tz(date, "YYYY-MM-DDTHH:mm", IST_TIMEZONE).toISOString();
}

export const parseNumberDate = (dateNum) => {
  const dateStr = `${dateNum}` 
  const year = dateStr.slice(0, 4);
  const month = dateStr.slice(4, 6);
  const day = dateStr.slice(6, 8);

  const formattedDate =`${year}-${month}-${day}`;
  
  return formattedDate;
};

export const parseWithDrawData = (user, dateTime, page, size, mainTabIndex, subTabIndex, type ) => {
  
  let data = { page, size };
  
  if(Object.keys(user).length !== 0) {
    const removeEmptyValue =  Object.fromEntries(
      Object.entries(user).filter(([key, value]) => value !== null && value !== undefined && value !== '')
    );
      data = {...data, ...removeEmptyValue};
  }

  if(Object.keys(dateTime).length !== 0) {
   const removeEmptyValue =  Object.fromEntries(
      Object.entries(dateTime).filter(([key, value]) => value !== null && value !== undefined && value !== '')
    );
      data = {...data, ...removeEmptyValue};
  }
  data.request_status = WITHDRAWAL_STATUS[mainTabIndex];
  data.range = WITHDRAWAL_RANGE[Object.values(subTabIndex)];
  data.type = type;

  return data;
}

export const getFormattedValue = (value) => {

  return value !== undefined && value !== null ? value.toFixed(2) : "0.00";

};

export const getWalletType = (type) => {
  console.log("type",type);

  const wallet = walletType.filter((item)=> item.value == type);
  console.log("wallet",wallet);
  return wallet[0]?.label;

 }    

 export const parseRefreshWithDrawData = ( page, size, mainTabIndex, subTabIndex, type ) => {
  
  let data = { page, size };
  
  data.request_status = WITHDRAWAL_STATUS[mainTabIndex];
  data.range = WITHDRAWAL_RANGE[Object.values(subTabIndex)];
  data.type = type;

  return data;
}

export const parseDateWiseRevenue = async(user, dateTime, monthYear, page, size ) => {
  
  let data = { page, size, month_year: monthYear };
 
  if(Object.keys(user).length !== 0) {
    const removeEmptyValue =  Object.fromEntries(
      Object.entries(user).filter(([key, value]) => value !== null && value !== undefined && value !== '')
    );
      data = {...data, ...removeEmptyValue};
  }

  if(Object.keys(dateTime).length !== 0) {
   const removeEmptyValue =  Object.fromEntries(
      Object.entries(dateTime).filter(([key, value]) => value !== null && value !== undefined && value !== '')
    );
      data = {...data, ...removeEmptyValue};
  }
  
  return data;
}

export const getPageSNo = (currentPage, index) => {
  const sno = (currentPage * 20) - 20 + (index + 1);
  return sno;
}

export const stripBaseUrl = (url) => {
  if (!url) return '';
  return url.startsWith(BASE_URL) ? url.replace(BASE_URL, '') : url;
};

// Display-only masking — never send this to the backend or use it to search/match.
// Keeps the last 4 digits visible (e.g. "******4567"); shorter/invalid values just
// get every character but the last 4 starred out, so it degrades gracefully.
export const maskPhone = (phone) => {
  const digits = String(phone ?? '').trim();
  if (!digits) return '';
  if (digits.length <= 4) return digits;
  return '*'.repeat(digits.length - 4) + digits.slice(-4);
};

